import c from 'classnames';
import PricingPageComponent, { frequencyToTitle } from '../../../common/PricingPageComponent';
import { PricingPage } from '../../../types/pricingPage';

interface Props {
    page: PricingPage;
    centered?: boolean;
    hideCustomCSS?: boolean;
    zoom?: 50 | 75 | 100;
}

export default function Preview({ page, centered = true, hideCustomCSS = false, zoom }: Props) {
    return (
        <div className={(c('min-h-full'), zoom ? `scale-${zoom} 2xl:scale-100` : undefined)}>
            <PricingPageComponent
                centered={centered}
                emptyContent={(frequency: string) => (
                    <div className="flex place-content-center h-40">
                        <div className="font-bold place-self-center">
                            Select {frequencyToTitle(frequency, 1, page.settings)} products to generate a preview.
                        </div>
                    </div>
                )}
                emptyFeature={<DummyFeatures />}
                page={page}
                disabled
                hideCustomCSS={hideCustomCSS}
            />
        </div>
    );
}

function DummyFeatures() {
    return (
        <>
            <p className="flex items-center mb-2 text-gray-600">-</p>
            <p className="flex items-center mb-2 text-gray-600">-</p>
            <p className="flex items-center mb-2 text-gray-600">-</p>
        </>
    );
}
